// 按需引入element控件
import 'element-ui/lib/theme-chalk/index.css';
import './element-locale'
import Vue from 'vue'
import {
  Aside, Badge, Breadcrumb, BreadcrumbItem, Button, ButtonGroup, Checkbox, CheckboxGroup, Col, Container, Card,
  DatePicker, Drawer, Descriptions, DescriptionsItem, Dropdown, DropdownMenu, DropdownItem, Dialog, Divider,
  Header, Icon, Image, Input, InputNumber, Form, FormItem, Footer, Loading,
  Main, Menu, MenuItem, MenuItemGroup, Message, MessageBox, Notification,
  Option, Pagination, PageHeader, Progress, Popover, Radio, RadioButton, RadioGroup, Row,
  Submenu, Select, Table, Tag, Transfer, TableColumn, Tooltip,
  Upload,
  Switch,
  Empty,
} from 'element-ui'
Vue.use(Aside)
Vue.use(Badge)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Button)
Vue.use(ButtonGroup)
Vue.use(Card)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Col)
Vue.use(Container)
Vue.use(DatePicker)
Vue.use(Descriptions)
Vue.use(DescriptionsItem)
Vue.use(Drawer)
Vue.use(Divider)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Dialog)
Vue.use(Empty)
Vue.use(Header)
Vue.use(Main)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Footer)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Icon)
Vue.use(Image)
Vue.use(Option)
Vue.use(Pagination)
Vue.use(PageHeader)
Vue.use(Progress)
Vue.use(Popover)
Vue.use(Row)
Vue.use(Radio)
Vue.use(RadioButton)
Vue.use(RadioGroup)
Vue.use(Select)
Vue.use(Submenu)
Vue.use(Tooltip)
Vue.use(Table)
Vue.use(Tag)
Vue.use(TableColumn)
Vue.use(Transfer)
Vue.use(Upload)
Vue.use(Switch)
// 重写message
const messageTypes = ["success", "error", "warning", "info"];
const message = {}
messageTypes.forEach((item) => {
  message[item] = (msg) => {
    return Message({
      showClose: true,
      type: item,
      message: msg
    })
  }
})
Vue.prototype.$message = message;

// 挂载MessageBox
Vue.prototype.$confirm = MessageBox.confirm
// Vue.prototype.$prompt = MessageBox.prompt

// 挂载Notification
const notify = Notification
Vue.prototype.$notify = notify

// 挂载Alert
Vue.prototype.$alert = MessageBox.alert

// 挂载prompt
Vue.prototype.$prompt = MessageBox.prompt


// 注册 v-loading 指令
Vue.use(Loading.directive)

// 如果需要全局的 loading 服务，也注册
Vue.prototype.$loading = Loading.service



// WEBPACK FOOTER //
// ./src/utils/element.js